import AnswerText from './AnswerText';
import NoAnswer from './NoAnswer';

interface TextAnswerProps {
    answer: string;
}

const TextAnswer: React.FC<TextAnswerProps> = ({ answer }) => {
    if (answer === '') {
        return <NoAnswer />;
    }

    return <AnswerText sx={{ fontWeight: 'medium' }}>{answer}</AnswerText>;
};

export default TextAnswer;
